import { useEffect, useState } from 'react';
import { TimezoneUtils } from './timezoneUtils';
import { normalizeGMTOffsetString } from '../configs/timezones';

/**
 * 平台登入使用者時區（GMT 偏移字串，如 UTC+8）。
 * 與 CompanyUserAdminPage / WorkflowListPage 一致，來自 localStorage userInfo.timezone。
 */
export function useCommerceUserTimezone() {
  const [userTimezoneOffset, setUserTimezoneOffset] = useState('UTC+8');

  useEffect(() => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      if (userInfo.timezone) {
        setUserTimezoneOffset(normalizeGMTOffsetString(userInfo.timezone));
      }
    } catch {
      /* ignore */
    }
  }, []);

  return userTimezoneOffset;
}

/** UTC 時間戳 → 使用者時區顯示 */
export function formatCommerceDateTime(value, userTimezoneOffset, format = 'YYYY-MM-DD HH:mm') {
  if (value == null || value === '') return '-';
  return TimezoneUtils.formatDateWithTimezone(value, userTimezoneOffset, format);
}

/** UTC 時間戳 → 使用者時區的日期（YYYY-MM-DD） */
export function formatCommerceDateOnly(value, userTimezoneOffset) {
  return formatCommerceDateTime(value, userTimezoneOffset, 'YYYY-MM-DD');
}

export function pickAuditTimestamp(record, camelKey, snakeKey) {
  if (!record) return null;
  if (record[camelKey] != null && record[camelKey] !== '') return record[camelKey];
  if (snakeKey && record[snakeKey] != null && record[snakeKey] !== '') return record[snakeKey];
  return null;
}

/**
 * 列表最右側（操作欄之前）的建立／更新時間欄。
 */
export function buildCommerceAuditColumns(t, userTimezoneOffset, options = {}) {
  const { width = 150, format = 'YYYY-MM-DD HH:mm' } = options;
  return [
    {
      title: t('common.createdAt'),
      key: 'createdAt',
      width,
      render: (_, r) =>
        formatCommerceDateTime(
          pickAuditTimestamp(r, 'createdAt', 'created_at'),
          userTimezoneOffset,
          format
        ),
    },
    {
      title: t('common.updatedAt'),
      key: 'updatedAt',
      width,
      render: (_, r) =>
        formatCommerceDateTime(
          pickAuditTimestamp(r, 'updatedAt', 'updated_at'),
          userTimezoneOffset,
          format
        ),
    },
  ];
}
